import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const wbsInitialCol = (gantt, t) => {
  const name = 'WBS_INITIAL_COL';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name: name,
    label: '',
    hide: !isVisible,
    data_type: 'string',
    ignore_as_column: true,
    template: (activity) => {
      if (!activity) return;
      const taskLevel = activity?.$level;
      const childBeforeClass = `proplanner-wbs-color-${taskLevel}-child-before`;
      const parentBeforeClass = `proplanner-wbs-color-${taskLevel}-before`;
      const isParent = gantt.hasChild(activity.id);
      return `<div class="${isParent ? parentBeforeClass : childBeforeClass}"></div>`;
    },
  };
};

export default wbsInitialCol; 